/**
 * Embed Keys Module Configuration
 *
 * Manages embed keys for public showcase map embedding.
 * Hidden from top-level sidebar — accessed via Settings navigation group.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const embedKeysModule: AppModule = {
    id: 'embed-keys',

    navigation: {
        label: 'Embed Keys',
        icon: 'code',
        path: '/embed-keys',
        order: 91,
        moduleKey: 'settings.embed_keys',
        showInSidebar: false, // Accessed via Settings group


        pages: [
            {
                label: 'All Embed Keys',
                path: '/embed-keys',
            },
            {
                label: 'Create Embed Key',
                path: '/embed-keys/create',
            },
        ],
    },

    routes,
}

export default embedKeysModule
